"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMapsContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const api_1 = require("@react-google-maps/api");
const react_i18next_1 = require("react-i18next");
const language_enum_1 = require("../../types/language-enum");
// Workaround for false performance warning - https://github.com/JustFly1984/react-google-maps-api/issues/238#issuecomment-767851686
const LIBRARIES = ["places"];
const GOOGLE_MAPS_API_KEY = (_a = process.env.REACT_APP_GOOGLE_MAP_API_KEY) !== null && _a !== void 0 ? _a : '';
const GOOGLE_MAP_IDS = (_b = process.env.REACT_APP_GOOGLE_MAP_ID) !== null && _b !== void 0 ? _b : '';
const GOOGLE_MAP_VERSION = "3.52";
const GOOGLE_MAP_REGION = "CA";
exports.GoogleMapsContext = react_1.default.createContext({
    isLoaded: false,
    loadError: undefined,
    url: "",
});
const GoogleMapsContextProvider = ({ apiKey, mapId, children }) => {
    var _a;
    const { i18n } = (0, react_i18next_1.useTranslation)();
    const mapsContextValue = (0, api_1.useLoadScript)({
        googleMapsApiKey: apiKey ? apiKey : GOOGLE_MAPS_API_KEY,
        mapIds: [mapId ? mapId : GOOGLE_MAP_IDS],
        version: GOOGLE_MAP_VERSION,
        region: GOOGLE_MAP_REGION,
        language: (_a = i18n.language) !== null && _a !== void 0 ? _a : language_enum_1.Language.EN,
        libraries: LIBRARIES,
    });
    return ((0, jsx_runtime_1.jsx)(exports.GoogleMapsContext.Provider, Object.assign({ value: mapsContextValue }, { children: children })));
};
exports.default = GoogleMapsContextProvider;
